module.exports = __webpack_public_path__ + "img/Wp_2005.f7bb9270.png";